import styled, { css } from 'styled-components';
import { ifProp } from 'styled-tools';
import { media, layout } from '@prisjakt/ui-base';
import Button from '@prisjakt/ui-button';
import { Truncated } from '../../../../../components/truncated';

type ABTestProps = {
  showLargerImage: boolean;
};

const cardImageSmall = css`
  padding: ${layout.spacing.xSmall} ${layout.spacing.small};
`;
const cardImageLarge = css`
  padding: ${layout.spacing.xSmall} ${layout.spacing.xxSmall};
  ${media.mediumUp`
    padding: ${layout.spacing.xSmall} ${layout.spacing.small};
  `};
`;

export const Card = styled.div.attrs({ 'data-test': 'OfferCard' })<ABTestProps>`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1 0 50%;
  align-self: stretch;
  width: 100%;
  min-height: 100%;
  min-width: ${layout.productCardMinWidthMobile};
  max-width: ${layout.productCardMaxWidth};
  text-align: ${ifProp('textCenter', 'center', 'left')};
  ${media.mediumUp`
    flex: 1 0 ${layout.productCardMinWidth};
  `};
  ${({ showLargerImage }) =>
    showLargerImage ? cardImageLarge : cardImageSmall}
`;

export const CardZone = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const productImageImageSmall = css`
  height: 90px;
  width: 90px;
  margin: 10px auto 20px auto;
  ${media.mediumUp`
    height: 130px;
    width: 130px;
  `};
`;
const productImageImageLarge = css`
  height: ${layout.productCardImageSize};
  width: ${layout.productCardImageSize};
  margin: 0 auto;
  img {
    max-height: 100%;
  }
`;

export const ProductImage = styled.div<ABTestProps>`
  align-items: center;
  box-sizing: content-box;
  order: 0;
  text-align: center;
  border-radius: ${layout.borderRadius};
  display: flex;
  justify-content: center;
  align-items: center;
  ${({ showLargerImage }) =>
    showLargerImage ? productImageImageLarge : productImageImageSmall};
  img {
    max-height: 100%;
  }
`;

const productDetailsImageLarge = css`
  padding: 0 ${layout.spacing.xxSmall};
  ${media.mediumUp`
  padding: 0;
`}
`;
export const ProductDetails = styled.div<ABTestProps>`
  position: relative;
  display: flex;
  flex-direction: column;
  flex: ${ifProp('stretch', '1 0 auto', '0 0 auto')};
  padding: 0 ${layout.spacing.xxSmall};
  ${media.mediumUp`
    padding: 0;
  `}
  ${({ showLargerImage }) => showLargerImage && productDetailsImageLarge}
`;
export const Company = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  flex: ${ifProp('stretch', '1 0 auto', '0 0 auto')};
`;

export const ProductName = styled(Truncated).attrs({
  'data-test': 'ProductName',
})`
  margin-top: 5px;
  overflow-wrap: break-word;
`;

export const LogoContainer = styled.div``;

const priceInfoImageSmall = css`
  padding: 1rem 0;
`;
const priceInfoImageLarge = css`
  padding: 0 ${layout.spacing.xxSmall} ${layout.spacing.xSmall};
  ${media.mediumUp`
    padding: 0 0 ${layout.spacing.xSmall} 0;
  `}
`;

export const PriceInfo = styled.div<ABTestProps>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${({ showLargerImage }) =>
    showLargerImage ? priceInfoImageLarge : priceInfoImageSmall}
`;

export const NonFeaturedButton = styled(Button)`
  width: 100%;
  opacity: 0.4;
  cursor: default;
`;

export const TransparencyShopInfo = styled.div`
  text-align: left;
  margin: 0;
`;
